import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, StatusWarning } from '_components';
import styles from './Common.module.css';


class AlTemplateTherActRow extends React.Component {

    render() {
        return (
            <div className={styles.row}>
                <CheckBox
                    size='extra-small'
                    className={styles.checkbox}
                    checked={this.props.activity.selected}
                    title={this.props.desc}
                    label={this.props.desc}
                    onClick={() => this.props.toggleItem({ entity: 'MLTMPTHERACT', entityKeyColumn: 'XLTMPTANO', entityKeyValue: this.props.activity.XLTMPTANO })}
                />
                { !this.props.activity.valid &&
                    <span className={styles.warning}>
                        <StatusWarning size='extra-small' title='Not Reimbursable based on Payer/Contract' />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        toggleItem: bindActionCreators(noteActions.alTemplateToggleItem, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let activity = state.entities.notes.MLTMPTHERACT[ownprops.id];

    let taname = activity.XLTMPTATANO ? state.entities.masterData.MLMASTERTHERACT[activity.XLTMPTATANO].TANAME + ' - ' : '';
    let act = activity.XLTMPTAACTIVITY ? activity.XLTMPTAACTIVITY + ' - ' : '';
    let setsReps = activity.XLTMPTASETSREPS ? activity.XLTMPTASETSREPS + ' - ' : '';
    let desc = taname + act + setsReps;
    desc = desc.endsWith(' - ') ? desc.slice(0, -3) : desc;

    return {
        noteId: noteId,
        activity: activity,
        desc: desc
    };
}

const connectedAlTemplateTherActRow = connect(mapStateToProps, mapDispatchToProps)(AlTemplateTherActRow);
export { connectedAlTemplateTherActRow as AlTemplateTherActRow };

